import React, { useState } from "react";
import { createPortal } from "react-dom";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";

import css from "./ClientComponent.module.css";
import { ButtonDelete, ModalForDelete } from "../../../ui";
import { clientsActions } from "../../../store/slices/clients-slices";
import { clientsService } from "../../../services/clients-services";
import ClientsCreateInfoModal from "../clientsSectionModal/ClientsCreateInfoModal/ClientsCreateInfoModal";
import ClientsCreateInfoModalMEELZ from "../clientsSectionModal/ClientsCreateInfoModal/ClientsCreateInfoModalMEELZ";
import { getConfig } from "../../../config";

const ClientComponent = ({ client, page }) => {
  const [isOpenUpdate, setIsOpenUpdate] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const dispatch = useDispatch();

  const {
    id,
    phoneNumber,
    clientName,
    apartmnetNumber,
    buidlingNumber,
    deliveryStreet,
    devlieryCity,
    points,
    role,
  } = client;

  const handleRowClick = () => {
    setIsOpenUpdate(true);
  };

  const handleDeleteButtonClick = (e) => {
    e.stopPropagation(); // Prevent row click when delete button is clicked
    setIsOpenDeleteModal(true);
  };

  const handleDeleteClick = async () => {
    try {
      await clientsService.deleteById(id);
      dispatch(clientsActions.changeTrigger());

      toast.success("Client has been deleted successfully!");
      setIsOpenDeleteModal(false);
    } catch (error) {
      console.error("Error deleting client:", error);
      toast.error("Failed to delete the client");
    }
  };

  return (
    <div
      className={css.wrap}
      onClick={handleRowClick}
      style={{ cursor: "pointer" }}
    >
      <div className={css.contact}>{phoneNumber}</div>

      <div className={css.name}>{clientName}</div>

      <div className={css.address}>
        {devlieryCity} {deliveryStreet} {buidlingNumber}/{apartmnetNumber}
      </div>

      <div className={css.points}>{points}</div>

      <div className={css.roles}>{role}</div>

      <div className={css.actions}>
        <ButtonDelete onClick={handleDeleteButtonClick} />
      </div>

      {isOpenUpdate &&
        createPortal(
          getConfig().projectCode === "MEELZ" ? (
            <ClientsCreateInfoModalMEELZ
              client={client}
              setIsOpenUpdate={setIsOpenUpdate}
              page={page}
            />
          ) : (
            <ClientsCreateInfoModal
              client={client}
              setIsOpenUpdate={setIsOpenUpdate}
              page={page}
            />
          ),
          document.body
        )}

      {isOpenDeleteModal && (
        <ModalForDelete
          handleDeleteClick={handleDeleteClick}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          name={"client"}
        />
      )}
    </div>
  );
};

export default React.memo(ClientComponent);
